import React from 'react';
import { Control, Controller, FieldErrorsImpl } from 'react-hook-form';
import { Typography } from '@navi/web-ui/lib/primitives';
import ErrorIconOutline from '@cp/src/assets/icons/ErrorIconOutline';
import Dropdown from '@cp/src/components/Dropdown';
import cx from 'classnames';
import RequiredIcon from '@navi/web-ui/lib/icons/RequiredIcon';
import { AgentFormValues } from '../../interfaces/types';
import { IOption } from '@cp/src/components/FilterDrawer/types';

type AgentFormRolesDropdownProps = {
  control: Control<AgentFormValues, any>;
  name: keyof AgentFormValues;
  errors: Partial<FieldErrorsImpl<AgentFormValues>>;
  isEditDisabled: boolean | undefined;
  styles: CSSModuleClasses;
  validationMessage: string;
  options: IOption[];
};

const AgentFormRolesDropdown: React.FC<AgentFormRolesDropdownProps> = props => {
  const { control, errors, name, isEditDisabled, styles, validationMessage, options } = props;

  return (
    <>
      <div className={styles.textContainer}>
        <Typography variant="p4" color="var(--navi-color-gray-c2)">
          Agent Access
        </Typography>
        <RequiredIcon />
      </div>
      <Controller
        control={control}
        name={name}
        rules={{
          validate: value => {
            return value?.length ? true : false;
          }
        }}
        render={({ field: { onChange, value } }) => (
          <Dropdown
            placeholder={'Enter here'}
            placeholderColor={'var(--navi-color-gray-c3)'}
            showSolidArrow={true}
            arrowIconWidth={9}
            options={options}
            onSelectionChange={onChange}
            multiSelect={true}
            selectedValue={value}
            containerClasses={styles.dropdownContainer}
            disabled={isEditDisabled}
            error={errors && errors[name] && errors[name].message}
            showEllipsisTooltip={true}
            pickerContainerClasses={'max-h-[266px]'}
            showTextCursorOnDisabled={true}
            tabIndexEnabled={true}
          />
        )}
      />
      {errors && errors?.roles && (
        <div className={styles.errorContainer}>
          <ErrorIconOutline />
          <Typography variant="p4" className={styles.errorText}>
            {validationMessage}
          </Typography>
        </div>
      )}
    </>
  );
};

export default AgentFormRolesDropdown;
